module.exports = __webpack_public_path__ + "src/assets/img/34.7bc16c27.svg";